<template>
  <div class="player-control" @mousemove="mousemove">
    <div v-show="isSHowProgress" ref="progressContainer" class="progressContainer">
      <div ref="progressBar" class="progressBar"></div>
    </div>
    <div class="bottomButtons">
      <!-- 暂停 -->
      <img @click.stop="togglePlay" v-if="!paused" src="./img/play.png" alt class="stop" />

      <!--
<span
  @click="togglePlay"
  v-if="!paused"
  class="play_img iconfont stop font_family"
  style="font-size: 36px; color: #ffffff; cursor: pointer"
  >&#xe683;</span
>
-->
      <img @click.stop="togglePlay" v-else :src="require('@/assets/live/play.png')" alt class="stop" />

      <!--
<span
  @click="togglePlay"
  v-else
  alt
  class="play_img iconfont stop font_family"
  style="font-size: 36px; color: #ffffff; cursor: pointer"
  >&#xe678;</span
>
-->

      <!-- 刷新 -->
      <!-- <img @click.stop="refresh" src="./img/refresh.png" alt class="refresh" /> -->

      <!-- 标题 -->
      <div class="title">{{ title }}</div>

      <!--
<i class="el-icon-refresh-right refresh" @click="refresh"></i>
-->
      <div style="flex: 1"></div>
      <!-- <div>
  <img @click.stop="goFeedback" src="./img/feedback.png" alt class="feedback" />
</div> -->

      <!-- 音量控件 -->

      <img @click.stop="toggleVol" v-if="cVolume > 0" :src="require('@/assets/live/voice.png')" alt
        class="volume volume-on" />
      <img @click.stop="toggleVol" v-else src="./img/sound_off.png" alt class="volume" />
      <div class="volume-slider">
        <el-slider v-model="cVolume" input-size="mini" :show-tooltip="false" />
      </div>

      <!-- 弹幕开关 -->
      <div v-if="bulletFlag" @click.stop="closeDan">
        <img v-if="bulletChat" :src="require('@/assets/live/active.png')" alt class="bullet-chat" />
        <img v-else :src="require('@/assets/live/default.png')" alt class="bullet-chat" />
      </div>

      <div class="definition" @click.stop="showDefinition" @mouseleave="closeDefinition">
        <span>{{ currentQuality.name }}</span>
        <div v-if="definitionFlag" class="chooleQualityQ" @mouseover="showDefinition" @mouseout="closeDefinition">
          <div class="chooleQuality">
            <div v-for="item in qualityName" :key="item.id" @click.stop="changeQuality(item)" class="danmu"
              :class="[item.id === currentQuality.id ? 'active' : '']">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <img v-if="!isHomePlay" @click.stop="fullscreen" :src="full
    ? require('@/assets/img/player-control/home_bfq_xiaoping.png')
    : require('@/assets/img/player-control/home_bfq_quanping.png')
    " class="full" alt />
      <div v-else class="go_in" @click.stop="enterRoom(detail)">
        <span>{{ $t("pc.liveIn") }}</span>
        <img :src="require('@/assets/live/frame.png')" alt="" />
      </div>
    </div>

  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapMutations, mapState } from "vuex";
import { enterRoom } from "@/util/enterRoomTicket";
export default {
  name: "player-control",
  components: {},
  props: {
    idx: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default() {
        return null;
      },
    },
    anchorid: {
      type: Number,
      default: 0,
    },
    paused: {
      type: Boolean,
      default: false,
    },
    currentQuality: {
      type: Object,
      default: () => ({}),
    },
    qualityName: {
      type: Array,
      default: [],
    },
    full: {
      type: Boolean,
      default: true,
    },
    volume: {
      type: Number,
      default: 50,
    },
    bulletFlag: {
      type: Boolean,
      default: true,
    },
    isHomePlay: {
      type: Boolean,
      default: false,
    },
    isSHowProgress: {
      type: Boolean,
      default: false,
    },
    loadingFlag: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    volume: {
      handler(n, o) {
        this.cVolume = n;
      },
      immediate: true,
    },
    cVolume(newVal) {
      this.$emit("changeVol", newVal);
      // clearTimeout(this.timer);
      // this.timer = setTimeout(() => {
      //   this.$emit("changeVol", newVal);
      // }, 100);
    },
    loadingFlag(loading) {
      console.log(loading, 'loadingloading')
      if (!loading) {
        const video = document
          .getElementById("liveMatchesTwoPlayer")
          ?.querySelector("video");
        if (video) {
          // 进度
          video?.addEventListener('timeupdate', () => {
            const percentage = (video.currentTime / video.duration) * 100;
            // currentProcessValue.value = percentage;
            this.$refs.progressBar.style.width = `${percentage}%`;
          });
          this.$refs.progressContainer.addEventListener('click', (e) => {
            e.stopPropagation();
            const rect = this.$refs.progressContainer.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const newTime = (offsetX / this.$refs.progressContainer.offsetWidth) * video.duration;
            video.currentTime = newTime;
          });
        }
      }
    }
  },
  data() {
    return {
      cVolume: 50,
      // full: false,
      bulletChat: true,
      definitionFlag: false,
      appendToStatus: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    // console.log("created: ",this.idx);
  },
  mounted() {
    this.bulletChat = localStorage.getItem("bulletChat")
      ? JSON.parse(localStorage.getItem("bulletChat"))
      : true;
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.definitionTime);
    this.$off("togglePlay");
    this.$off("toggleVol");
    // this.$off("toggleDan");
    this.$off("changeVol");
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    enterRoom,
    goFeedback() {
      console.log("go feedback service");
    },
    // enterRoom() {
    //   console.log(this.detail);
    //   if (this.detail.ticket > 0 && this.detail.ticket_paid === 2) {
    //     if (!this.userInfo.id) {
    //       this.toggleLogin();
    //       return;
    //     }
    //     this.$refs.ticket.open();
    //   } else {
    //     this.$router.push(`/liveMatchesTwo/${this.detail.anchorid}`);
    //   }
    // },
    mousemove() {
      console.log("mousemove");
      // if (this.idx == 2 && !this.appendToStatus) {
      //   document.getElementById("liveMatchesTwoPlayer").appendChild(this.$el);
      //   this.appendToStatus = true;
      // }
    },
    changeQuality(item) {
      // if (item.id === 2 && !this.userInfo.id) {
      // this.toggleLogin()
      // return false;
      // }
      this.$emit("qualityUrl", item);
    },
    showDefinition() {
      if (this.definitionTime) {
        clearTimeout(this.definitionTime);
      }
      this.definitionFlag = true;
    },
    closeDefinition() {
      this.definitionTime = setTimeout(() => {
        this.definitionFlag = false;
      }, 300);
    },
    refresh() {
      // this.$emit("refresh");
    },
    togglePlay() {
      this.$emit("togglePlay");
    },
    toggleVol() {
      this.$emit("toggleVol");
      /*
      if (this.volume > 0) {
        this.volume = 0;
      } else {
        this.volume = 50;
      }
      */
    },
    // changeVol(volume) {
    //   this.$emit("changeVol", volume);
    // },
    closeDan() {
      this.bulletChat = !this.bulletChat;
      localStorage.setItem("bulletChat", this.bulletChat);
      this.$emit("toggleDan", this.bulletChat);
    },
    fullscreen() {
      // this.full = !this.full;
      this.$emit("fullscreen", !this.full);
      // console.log("333333333333333333333333",this.$el)
    },
  },
};
</script>

<style scoped lang="scss">
.player-control {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  height: 0.52rem;
  background: linear-gradient(90deg,
      #100606 5.29%,
      #100707 83.56%,
      #7b0000 103.7%);

  transform: translate3d(0, 100%, 0);
  transition: all 0.3s;
  z-index: 5;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .progressContainer {
    width: 100%;
    background-color: #e0e0e0;
    height: 0.05rem;
    cursor: pointer;
    position: relative;

    .progressBar {
      width: 0;
      height: 100%;
      background-color: rgba(208, 45, 84, 1);
      position: absolute;
      top: 0;
      left: 0;
    }
  }



  .bottomButtons {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .stop {
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.27rem;
    cursor: pointer;
  }

  .play_img {
    margin-top: -15px;
  }

  .refresh {
    cursor: pointer;
    color: #fff;
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.27rem;
  }

  .feedback {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.2rem;
    cursor: pointer;
  }

  .feedback:hover {
    content: url("./img/feedback_hover.png");
  }

  .volume-slider {
    width: 1rem;
    transform-origin: 0;
    margin: 0px 0.15rem;
    margin-right: 0.2rem;
  }

  .voice_img {
    margin-top: -0.12rem;
  }

  .volume {
    width: 0.24rem;
    height: 0.24rem;
    cursor: pointer;
  }

  /* .volume-on:hover {
    content: url("./img/sound_hover.png");
  } */

  .bullet-chat {
    width: 0.48rem;
    height: 0.2rem;
    margin-right: 0.2rem;
    cursor: pointer;
  }

  // .toggle-button {
  //   position: relative;
  //   display: inline-block;
  //   width: 50px;
  //   height: 20px;
  //   margin: 0 20px;
  //   vertical-align: top;
  //   background: #333;
  //   opacity: 0.8;
  //   border-radius: 30px;
  //   outline: none;
  //   cursor: pointer;
  //   appearance: none;
  //   transition: all 0.3s cubic-bezier(0.2, 0.85, 0.32, 1.2);
  // }
  // .toggle-button::after {
  //   content: "";
  //   display: inline-block;
  //   position: absolute;
  //   left: 3px;
  //   top: 2px;
  //   width: 12px;
  //   height: 12px;
  //   background-clip: content-box;
  //   background-color: #02a8a2;
  //   border: 2px solid rgba(2, 168, 162, 0.3);
  //   border-radius: 50%;
  //   transform: translateX(calc(100% + 12px));
  //   transition: all 0.3s cubic-bezier(0.2, 0.85, 0.32, 1.2);
  // }
  // .toggle-button:checked::after {
  //   transform: translateX(0);
  //   background-color: #999;
  //   background-clip: content-box;
  //   border: 2px solid rgba(153, 153, 153, 0.3);
  // }
  // .toggle-button:checked {
  //   // background-color: blue;
  // }

  .title {
    height: 0.24rem;
    line-height: 0.24rem;
    font-size: 0.16rem;
    text-align: center;
    color: #999;
    font-weight: 400;
    max-width: 5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .definition {
    position: relative;
    text-align: center;
    color: #c4c4c4;
    cursor: pointer;
    width: 0.72rem;
    white-space: nowrap;
    height: 0.24rem;
    line-height: 0.24rem;
    background: rgba(51, 51, 51, 0.8);
    border-radius: 0.12rem;

    span {
      font-size: 0.14rem !important;
    }
  }

  .go_in {
    display: flex;
    align-items: center;
    margin-left: 44px;
    padding-right: 23px;
    cursor: pointer;

    span {
      color: #bcaaaa;
      font-size: 14px;
      font-weight: 400;
      margin-right: 6px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .chooleQualityQ {
    position: absolute;
    bottom: 0.3rem;
    width: 100%;
    padding-bottom: 0.1rem;
    box-sizing: border-box;
  }

  .chooleQuality {
    position: absolute;
    width: 100%;
    border-radius: 0.08rem;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    bottom: 0.1rem;

    div {
      font-size: 0.16rem;
      color: #ffffff;
      text-align: center;
      margin: 0 0 0.13rem;
      cursor: pointer;
    }

    div:first-child {
      margin-top: 0.11rem;
      margin-bottom: 0.13rem;
    }

    div:hover {
      color: rgba(255, 56, 56, 1);
    }

    .danmu {
      color: #c4c4c4;
    }

    .active {
      color: rgba(255, 56, 56, 1);
    }
  }

  .full {
    width: 0.24rem;
    height: 0.24rem;
    margin-left: 0.2rem;
    margin-right: 0.25rem;
    cursor: pointer;
  }

  ::v-deep {
    .el-slider__runway {
      background: #8b8686;
      height: 0.04rem !important;
    }

    .el-slider__button-wrapper {
      top: -0.08rem !important;
      height: 0.18rem;
      width: 0.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-slider__bar {
      height: 0.04rem !important;
      background: linear-gradient(90deg, #ff3c6b 0%, #d02d54 100%) !important;
    }

    .el-slider__button {
      box-sizing: content-box;
      width: 0.06rem !important;
      height: 0.06rem !important;
      background-color: #d02d54;
      border: 0.03rem solid #ffffff !important;
      background-image: none;
    }
  }
}
</style>
